// Patches raw CMS HTML before v-html: lazy-loads iframes and strips legacy
// Trustpilot TrustBox <script> embeds (the bootstrap is loaded once by GTM).
// Titles are set upstream, on the payload — server/plugins/video-iframe-titles.ts.
export function enhanceCmsIframes(html?: string): string {
  if (!html)
    return ''

  let out = stripTrustpilotEmbeds(html)

  if (out.includes('<iframe')) {
    out = out.replace(/<iframe\b([^>]*)>/gi, (_match, attrs: string) => {
      // (?<![\w-]) so data-loading= doesn't count as the attribute
      if (/(?<![\w-])loading\s*=/i.test(attrs))
        return `<iframe${attrs}>`
      return `<iframe loading="lazy"${attrs}>`
    })
  }

  return out
}

// Strip legacy TrustBox embeds (bootstrap <script> = the cookie source + the
// widget container); plain trustpilot.com anchor links are left untouched.
function stripTrustpilotEmbeds(html: string): string {
  if (!/trustpilot/i.test(html))
    return html

  return html
    .replace(/<script\s[^>]*trustpilot\.com[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<div\s[^>]*class=["'][^"']*\btrustpilot-widget\b[^"']*["'][\s\S]*?<\/div>/gi, '')
    .replace(/<!--\s*(?:end\s+)?trustbox[^>]*-->/gi, '')
}
